import { jsx as _jsx } from "react/jsx-runtime";
const OPTIONS = [
    {
        id: 'anywhere',
        label: 'Procurar em qualquer parte do texto',
        short: 'Qualquer parte',
    },
    {
        id: 'prefix',
        label: 'Procurar só no começo do texto',
        short: 'Começa com',
    },
    {
        id: 'exact',
        label: 'Só o código ou o código de barras inteiro, igualzinho',
        short: 'Exato',
    },
];
export const SearchModeToggle = ({ mode, onChange, }) => (_jsx("div", { role: "group", "aria-label": "Onde procurar o texto", className: "flex shrink-0 items-center gap-0.5 rounded-(--radius-md) border border-(--border-subtle) p-0.5", children: OPTIONS.map((option) => (_jsx("button", { type: "button", "aria-pressed": mode === option.id, title: option.label, onClick: () => {
            onChange(option.id);
        }, className: `rounded-(--radius-sm) px-2 py-1 text-(length:--text-xs) transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--brand-primary) ${mode === option.id
            ? 'bg-(--surface-raised) font-(--weight-medium) text-(--text-primary)'
            : 'text-(--text-secondary) hover:text-(--text-primary)'}`, children: option.short }, option.id))) }));
//# sourceMappingURL=search-mode-toggle.js.map